<template>
  <div>
    <div class="conten-right bullet" style="margin-bottom: 8px;">
      <img src="/assets/images/bn11-hd.png" class="banner">
    </div>
    <!-- <div class="iframe-box">
      <iframe id="iframe-l" src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe>
    </div> -->
    <div class="conten-right bullet" style="margin-bottom: 8px; margin-top: 10px;">
      <img src="/assets/images/bn12-hd.png" class="banner">
    </div>
    <ResultBox />
    <!-- <div class="iframe-box">
      <iframe id="iframe-l2" src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe>
    </div> -->
    <div class="conten-right bullet" style="margin-top: 10px;">
      <a href="https://xosoredcross.com/" target="_blank">
        <img src="/assets/images/redcross550x450.png" class="banner">
      </a>
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  created() {
    console.log('pathDate', this.$route.params.pathDate)
  }
}
</script>
<style lang="scss">
.my-result {
  // height: 450px;
  margin-bottom: 10px;
  width: calc(100% - 1px);
  margin: 0 auto;
}
.iframe-box {
  overflow: hidden;
}
#iframe-l {
  overflow: hidden;
  height: 420px;
  margin-left: -210px;
  margin-top: -180px;
  width: 740px;
  max-width: none;
}
</style>
